<template>
  <div class="outside">
    <div class="open-app">
      <div class="left-part">
        <img class="logo" :src="require(`@/assets/outside/${logoIcon}`)" alt="">
        <div class="title">
          <p>{{isXunMengTu ? '迅猛兔加速器' : '迅游手游加速器'}}</p>
          <p>{{isXunMengTu ? '永久免费加速' : '畅享游戏时光'}}</p>
        </div>
      </div>
      <div class="btn" @click="_open_app">打开App</div>
    </div>

    <div v-if="isWXGuideVisibility" class="wx-guide">
      <div class="mask"></div>
      <img class="arrow" :src="require('@/assets/outside/arrow.png')" alt="">
      <div class="guide-text">请点击右上角，在浏览器内打开</div>
    </div>

    <div class="download-btn" @click="_download_app">下载App</div>
  </div>
</template>

<script>
import { $isInWQ, $isXunMengTu } from '@/util/util'
import { mapState } from 'vuex'
import { DOWNLOAD_URL } from '@/config/global'

export default {
  name: 'OutSide',
  data() {
    return {
      AWAKE_LINK: 'launch://xyapp',
      AWAKE_LINK_IOS: 'https://www.xunyou.mobi/iOS_app/',
      XMT_AWAKE_LINK: 'launch://xunmengtu',
      XMT_AWAKE_LINK_IOS: 'https://www.xunmengtu.com/iOS_app/',
      isWXGuideVisibility: false,
      logoIcon: $isXunMengTu() ? 'xmt_logo.png' : 'logo.png',
      isXunMengTu:  $isXunMengTu()
    }
  },
  mounted() {
  },
  methods: {
    _open_app() {
      if ($isInWQ()) {
        this.isWXGuideVisibility = true
        return
      }

      if (this.isInIos && $isXunMengTu()) {
        window.location.href = this.XMT_AWAKE_LINK_IOS
      } else if (this.isInIos && !$isXunMengTu()) {
        window.location.href = this.AWAKE_LINK_IOS
      } else if (!this.isInIos && $isXunMengTu()) {
        window.location.href = this.XMT_AWAKE_LINK
      } else if (!this.isInIos && !$isXunMengTu()) {
        window.location.href = this.AWAKE_LINK
      }
    },
    _download_app() {
      if ($isInWQ()) {
        this.isWXGuideVisibility = true
        return
      }
      if (this.isInIos && $isXunMengTu()) {
        window.location.href = DOWNLOAD_URL.XMT_IOS
      } else if (this.isInIos && !$isXunMengTu()) {
        window.location.href = DOWNLOAD_URL.IOS
      } else if (!this.isInIos && $isXunMengTu()) {
        window.location.href = DOWNLOAD_URL.XMT_ANDROID
      } else if (!this.isInIos && !$isXunMengTu()) {
        window.location.href = DOWNLOAD_URL.ANDROID
      }
    }
  },
  computed: {
    ...mapState(['isInIos'])
  }
}
</script>

<style scoped lang="less">
.open-app {
  width: 100vw;
  height: 6rem;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.2rem;
  z-index: 20;
}

.left-part {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.btn {
  width: 9rem;
  height: 2.9rem;
  line-height: 2.9rem;
  background: #00D06A;
  border-radius: 1.6rem;
  font-size: 1.2rem;
  font-weight: 400;
  color: #FFF;
  text-align: center;
}

.logo {
  width: 4.6rem;
  height: 4.6rem;
  margin-right: 1.3rem;
}

.title p:nth-of-type(1) {
  font-size: 1.5rem;
  font-weight: 500;
  color: #F3F3F3;
  margin-bottom: 0.3rem;
}

.title p:nth-of-type(2) {
  font-size: 1.2rem;
  font-weight: 400;
  color: #A9A9A9;
}

.download-btn {
  width: 32.4rem;
  height: 4.8rem;
  line-height: 4.8rem;
  text-align: center;
  position: fixed;
  bottom: 5.1rem;
  left: 0;
  right: 0;
  margin: 0 auto;
  background: #00D06A;
  border-radius: 3.3rem;
  font-size: 2rem;
  font-weight: 400;
  color: #FFFFFF;
  z-index: 1;
}

.wx-guide {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10;
}

.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(9, 9, 9, 0.6);
}

.guide-text {
  width: 25.3rem;
  height: 4.3rem;
  line-height: 4.3rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
  color: #FFF;
  background: url("~@/assets/outside/panel.png") 0 0 no-repeat;
  background-size: contain;
  z-index: 20;
  position: absolute;
  top: 6.9rem;
  right: 2rem;
  padding-top: 0.2rem;
}

.arrow {
  height: 6.4rem;
  position: absolute;
  top: 0;
  right: 2rem;
  z-index: 20;
}
</style>
